import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { LoadingModule } from 'src/app/shared/components';
import { RegisterPageComponent } from './register-page.component';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
    declarations: [
        RegisterPageComponent
    ],
    exports: [
        RegisterPageComponent,
    ],
    imports: [
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        AngularSvgIconModule,
        LoadingModule,
        BrowserModule,
        ReactiveFormsModule,
        NgxMaskModule
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RegisterPageModule { }
